import { Bean } from '@dreryk/react-common';

import { FormsTemplateListItem } from '../FormsTemplates.types';

export const isItemActive = <ITEM extends Bean>(
   activeTemplate: FormsTemplateListItem<ITEM> | undefined,
   currentItem: FormsTemplateListItem<ITEM>
): boolean => {
   return Boolean(activeTemplate?.id === currentItem.id);
};
